export const QueryFunctions = ['loadarticle', 'elbridge'] as const;
export const QueryParams = ['articleNo', 'articleId', 'lang', 'refid', 'version'] as const;

export type QueryFunctionType = typeof QueryFunctions[number];
export type QueryParamType = typeof QueryParams[number];
